var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle-background",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F4F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "system-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16.9989C18.0002 15.95 18.3303 14.9277 18.9436 14.0767C19.5568 13.2258 20.4222 12.5892 21.4172 12.2571C22.4121 11.9251 23.4864 11.9144 24.4878 12.2265C25.4892 12.5386 26.3671 13.1577 26.9972 13.9963C27.6273 14.8348 27.9778 15.8503 27.999 16.899C28.0202 17.9477 27.711 18.9765 27.1152 19.8398C26.5195 20.7032 25.6673 21.3573 24.6793 21.7095C23.6913 22.0618 22.6176 22.0945 21.61 21.8029L19.707 23.7059C19.5195 23.8935 19.2652 23.9988 19 23.9989H18V24.9989C18 25.2641 17.8946 25.5185 17.7071 25.706C17.5196 25.8935 17.2652 25.9989 17 25.9989H16V26.9989C16 27.2641 15.8946 27.5185 15.7071 27.706C15.5196 27.8935 15.2652 27.9989 15 27.9989H13C12.7348 27.9989 12.4804 27.8935 12.2929 27.706C12.1054 27.5185 12 27.2641 12 26.9989V24.9989C12.0001 24.7337 12.1055 24.4794 12.293 24.2919L18.196 18.3889C18.0657 17.9371 17.9997 17.4691 18 16.9989ZM23 13.9989C22.8011 13.9989 22.6103 14.0779 22.4697 14.2186C22.329 14.3592 22.25 14.55 22.25 14.7489C22.25 14.9478 22.329 15.1386 22.4697 15.2792C22.6103 15.4199 22.8011 15.4989 23 15.4989C23.3978 15.4989 23.7794 15.6569 24.0607 15.9382C24.342 16.2195 24.5 16.6011 24.5 16.9989C24.5 17.1978 24.579 17.3886 24.7197 17.5292C24.8603 17.6699 25.0511 17.7489 25.25 17.7489C25.4489 17.7489 25.6397 17.6699 25.7803 17.5292C25.921 17.3886 26 17.1978 26 16.9989C26 16.2033 25.6839 15.4402 25.1213 14.8776C24.5587 14.315 23.7956 13.9989 23 13.9989Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyCircle);
export default __webpack_public_path__ + "static/media/key-circle.dfc753039ece48e40e4db64bfc01061a.svg";
export { ForwardRef as ReactComponent };